import * as React from 'react'
import { useDispatch } from 'react-redux'

import Popup from '../../../ui/popup'
import Button from '../../../ui/button'
import TextAreaField from '../../../form/TextAreaField'
import RadioGroupField from '../../../form/RadioGroupField'

import { Formik, Form, Field, FieldProps, FormikProps } from 'formik'

import { EditPhotoType } from '../../../../store/member/memberTypings'
import { SelectOption, PhotoType } from '../../../../store/commonTypes'

import { photoEdit } from '../../../../store/member/memberSlice'

interface Props {
    photo: PhotoType
    onClose: () => void
    onDelete: () => void
}

const visibilityOptions: SelectOption[] = [
    {
        value: 'free',
        label: 'Public'
    },
    {
        value: 'private',
        label: 'Private'
    },
    {
        value: 'pro',
        label: 'Premium'
    }
]

const EditPhoto: React.FunctionComponent<Props> = ({ onClose, photo, onDelete }: Props) => {
    const dispatch = useDispatch()

    const initialValues: EditPhotoType = {
        id: photo.id,
        album_type: photo.type,
        album_comments: photo.comments
    }

    return (
        <Popup onClose={onClose} title="Edit photo" classname="vertical" profile={true}>
            <Formik
                validateOnChange={false}
                initialValues={initialValues}
                onSubmit={(values: EditPhotoType): void => {
                    dispatch(photoEdit(values))
                    onClose()
                }}
            >
                {(props: FormikProps<EditPhotoType>) => {
                    const { submitForm } = props
                    return (
                        <Form className="form">
                            <div className="preview">
                                <img src={photo.url} alt="" />
                                <div className="uploadControls">
                                    <Button label="Save" type="button" onClick={submitForm} />
                                    <Button label="Delete" type="button" onClick={onDelete} tertiary />
                                </div>
                            </div>
                            <Field name="album_type">
                                {({ field, form }: FieldProps) => (
                                    <RadioGroupField
                                        form={form}
                                        field={field}
                                        label="Album"
                                        options={visibilityOptions}
                                    />
                                )}
                            </Field>
                            <Field name="album_comments">
                                {({ field, meta, form }: FieldProps) => (
                                    <TextAreaField
                                        form={form}
                                        field={field}
                                        error={meta.error}
                                        label="Description"
                                        placeholder="Photo description"
                                    />
                                )}
                            </Field>
                        </Form>
                    )
                }}
            </Formik>
        </Popup>
    )
}

export default EditPhoto
